export default __webpack_public_path__ + "static/media/portfolio-darkGrey.bf93e27e.svg";